import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function MobileAuthWrapper({ children }) {

  const location = useLocation();

  useEffect(() => {

    const token = localStorage.getItem('token');

    // Only redirect for mobile auth routes
    if (
      token &&
      location.pathname.startsWith('/mobile-auth')
    ) {

      window.location.href =
        `metatradify://auth?token=${token}`;
    }

  }, [location]);

  return children;
}